<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/colors";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/mixins";

  .card {
    display: flex;
    flex-direction: column;

    gap: utils.in_rem(12px);
    padding: utils.in_rem(12px);
    border-radius: 8px;

    background-color: colors.get(interfaceWhite);

    .date-and-title {
      display: flex;
      flex-direction: column;
      gap: utils.in_rem(4px);

      > .date-and-status {
        display: flex;
        justify-content: space-between;

        > .date {
          display: block;
          @include mixins.body4-badge();
          text-align: left;
        }
      }

      > .title {
        display: block;
        @include mixins.h4();
      }

      > .title-and-tag {
        display: flex;
        justify-content: space-between;
        @include mixins.h4();
      }
    }

    &.is-overlay {
      border: 1px solid colors.get(interfaceSwGrey_10);
    }

    &.focus {
      outline: 2px solid colors.get(primary_40);
      outline-offset: -2px; // keep the outline inside the card so it's not clipped
    }
  }

  a {
    &:hover {
      color: colors.get(primary_50);
      cursor: pointer;
    }
  }
</style>

<script>
  import StatusTag from "@sourcewhale/shared/svelte-design-system/components/atoms/TagsAndChips/StatusTag.svelte";
  import TruncatedText from "@sourcewhale/shared/svelte-design-system/components/utils/TruncatedText.svelte";
  import { formatDateWithOrdinal } from "../../../utils/time";
  import IconInformation from "./IconInformation.svelte";
  import { isOverlayStore } from "./stores";

  export let type; // news || jobs || funding
  export let item;
  export let status;
  export let tag;
  export let MAP;

  $: formattedItem = {
    ...item,
    date: item?.date
      ? formatDateWithOrdinal(Math.floor(new Date(item.date).getTime() / 1000))
      : null,
  };

  // Funding items have a different key for the title
  $: title = type === "funding" ? formattedItem.round : formattedItem.title;
  $: displayDate = type === "funding" ? undefined : formattedItem?.date;

  let isFocused = false;
  const onfocus = () => {
    isFocused = true;
  };
  const onblur = () => {
    isFocused = false;
  };
</script>

<!-- Want the card to have an outline when interacted with -->
<div class="card" class:focus={isFocused} class:is-overlay={$isOverlayStore}>
  <div class="date-and-title">
    {#if displayDate}
      <div class="date-and-status">
        <div class="date">Posted: {displayDate}</div>
        {#if status}
          <StatusTag
            kind={formattedItem.isOpen ? "success" : "warning"}
            contrast="low"
            size="small"
          >
            {status}
          </StatusTag>
        {/if}
      </div>
    {/if}
    {#if formattedItem.url}
      <a
        class="title"
        href={formattedItem.url}
        target="_blank"
        on:focus={onfocus}
        on:blur={onblur}
      >
        <TruncatedText text={title} limit="100" showReadMore={false} />
      </a>
    {:else}
      <div class="title-and-tag">
        <TruncatedText text={title} limit="100" showReadMore={false} />
        {#if tag}
          <StatusTag kind="neutral" contrast="low" size="small">
            {tag}
          </StatusTag>
        {/if}
      </div>
    {/if}
  </div>
  <IconInformation item={formattedItem} {MAP} size="small" />
</div>
